import { render, staticRenderFns } from "./NavBtm.vue?vue&type=template&id=09f0a415&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NavBtm.vue"
export default component.exports